import { render, staticRenderFns } from "./zone-country-areas.vue?vue&type=template&id=0d64b270"
import script from "./zone-country-areas.vue?vue&type=script&lang=js"
export * from "./zone-country-areas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports